import React from 'react';
import ReactLoading from 'react-loading';
import './IconLoading.css';

const IconLoading = ({type, color, width, height}) => {
	return ( 
		<ReactLoading type={type} color={color} height={height || 12} width={width || 14} className='react-loading-for-btn align-self-center me-2'/>
	);
}
 
export default IconLoading;